import { cn } from '@/libs/tw'

export type Styles =
	| 'none'
	| 'p-s'
	| 'p-s-bold'
	| 'p-ms'
	| 'p-ms-bold'
	| 'p'
	| 'p-bold'
	| 'p-m'
	| 'p-m-bold'
	| 'h3'
	| 'h2'
	| 'h1'

type StyleClasses = {
	[K in Styles]: string
}

export const fontStyles: StyleClasses = {
	none: '',
	['p-s']: cn('default-font text-[11px] font-[400] leading-[16px]'),
	['p-s-bold']: cn('default-font text-[11px] font-progressStepHeadline leading-[16px]'),
	['p-ms']: cn('default-font text-[14px] font-[400] leading-[24px]'),
	['p-ms-bold']: cn(
		'default-font text-[14px] font-[800] uppercase leading-[16px] tracking-[1px]'
	),
	p: cn('default-font text-[16px] font-[400] leading-[24px]'),
	['p-bold']: cn('default-font text-[16px] font-progressStepHeadline leading-[24px]'),
	['p-m']: cn('default-font text-[20px] font-[400] leading-[32px]'),
	['p-m-bold']: cn('default-font text-[20px] font-progressStepHeadline leading-[32px]'),
	h3: cn('default-font text-[24px] font-progressStepHeadline leading-[32px]'),
	h2: cn(
		'font-secondary text-[26px] font-progressStepHeadline leading-[32px] md:text-[28px] md:leading-[130%] md:tracking-progressStepHeadline'
	),
	h1: cn('font-secondary text-[40px] font-[700] leading-[48px]'),
}
